import { render, staticRenderFns } from "./PageDataLab.vue?vue&type=template&id=d849a7a4&scoped=true"
import script from "./PageDataLab.vue?vue&type=script&lang=js"
export * from "./PageDataLab.vue?vue&type=script&lang=js"
import style0 from "./PageDataLab.vue?vue&type=style&index=0&id=d849a7a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d849a7a4",
  null
  
)

export default component.exports